<script setup lang="ts">
type colorType = "info" | "warning" | "negative" | "positive" | "grey";
withDefaults(
    defineProps<{
        color?: colorType; // Color theme for the dialog
        title?: string; // Title of the dialog
        light?: boolean; // Use light theme
        noIcon?: boolean; // Do not show icon
    }>(),
    { color: "info", light: false }
);

const ICON_MAP = {
    grey: "fa-regular fa-circle-check",
    info: "fa-regular fa-circle-info",
    positive: "fa-regular fa-circle-check",
    warning: "fa-regular fa-circle-info",
    negative: "fa-regular fa-circle-exclamation",
};

const getIcon = (color: colorType) => ICON_MAP[color] || ICON_MAP.grey;
</script>

<template>
    <q-card :class="`${color} q-mb-md ${light ? 'light' : ''}`">
        <q-card-section>
            <div v-if="title" class="flex content-center items-center q-mb-sm">
                <q-icon
                    v-if="noIcon === false"
                    :color="color"
                    :name="getIcon(color)"
                    class="q-mr-sm"
                    aria-hidden="true"
                />

                <div class="alert-title">{{ title }}</div>
            </div>
            <div>
                <slot />
            </div>
        </q-card-section>
    </q-card>
</template>

<style scoped>
.q-card {
    border-radius: 4px;
    border: 1px solid #d0d0d0;
    border-left: 8px solid var(--q-confirm-highlight);

    &.grey {
        --q-confirm-highlight: #949393;
        &.light {
            --q-confirm-highlight: #e0e0e0;
        }
    }

    &.info {
        --q-confirm-highlight: var(--q-info);

        &.light {
            --q-confirm-highlight: #a6d8ff;
        }
    }

    &.positive {
        --q-confirm-highlight: var(--q-positive);

        &.light {
            --q-confirm-highlight: #c0ecc3;
        }
    }

    &.warning {
        --q-confirm-highlight: var(--q-warning);

        &.light {
            --q-confirm-highlight: #f3e4b8;
        }
    }

    &.negative {
        --q-confirm-highlight: var(--q-negative);

        &.light {
            --q-confirm-highlight: #ffa2a2;
        }
    }
}
.alert-title {
    font-weight: 600;
}
</style>
